
// utils/variantUtils.js
import { getLocalizedText } from '../../../../utils/multilingualUtils';

export const variantUtils = {
    getDisplayText: (item, language = 'en') => {
        // Check multiple possible variant field names based on data source
        const variantFields = [
            'displayVariant',     // Cart/checkout items
            'variant',            // Order items
            'variantName',        // Alternative naming
            'variantTitle',       // Alternative naming
            'selectedVariant',    // Alternative naming
            'productVariant'      // Alternative naming
        ];

        for (const field of variantFields) {
            if (item[field]) {
                const value = typeof item[field] === 'string'
                    ? item[field]
                    : item[field].name || item[field].title || item[field].display;

                if (value && typeof value === 'string' && value.trim() !== "") {
                    return value;
                }
            }
        }

        // If no display variant found, try to construct from individual fields (like color and size)
        const variantParts = [];

        // Handle color field (which might be JSON string)
        if (item.color) {
            try {
                const colorObj = typeof item.color === 'string' ? JSON.parse(item.color) : item.color;
                if (colorObj) {
                    // Handle multilingual color objects
                    if (colorObj.name) {
                        const colorText = getLocalizedText(colorObj.name, language);
                        if (colorText) variantParts.push(colorText);
                    } else {
                        // Try to get localized color directly
                        const colorText = getLocalizedText(colorObj, language);
                        if (colorText) variantParts.push(colorText);
                    }
                }
            } catch (e) {
                // If parsing fails, try to get localized text or use as string
                const colorText = getLocalizedText(item.color, language);
                if (colorText && colorText.trim() !== '') {
                    variantParts.push(colorText);
                }
            }
        }

        // Handle size field - now supports multilingual
        if (item.size) {
            try {
                // Try to parse as JSON first (multilingual)
                const sizeObj = typeof item.size === 'string' ? JSON.parse(item.size) : item.size;
                const sizeText = getLocalizedText(sizeObj, language);
                if (sizeText) {
                    variantParts.push(`Size ${sizeText}`);
                }
            } catch (e) {
                // Fallback to direct localization
                const sizeText = getLocalizedText(item.size, language);
                if (sizeText && sizeText.trim() !== '') {
                    variantParts.push(`Size ${sizeText}`);
                }
            }
        }

        // Handle other common variant fields - with multilingual support
        if (item.material) {
            const materialText = getLocalizedText(item.material, language);
            if (materialText && materialText.trim() !== '') {
                variantParts.push(materialText);
            }
        }

        if (item.style) {
            const styleText = getLocalizedText(item.style, language);
            if (styleText && styleText.trim() !== '') {
                variantParts.push(styleText);
            }
        }

        if (variantParts.length > 0) {
            return variantParts.join(' / ');
        }

        // If no display variant found, try to construct from variant attributes array
        if (item.variantAttributes && Array.isArray(item.variantAttributes)) {
            const attributeParts = item.variantAttributes
                .filter(attr => attr.value && typeof attr.value === 'string' && attr.value.trim() !== "")
                .map(attr => {
                    // Try to get localized value
                    try {
                        const parsedValue = JSON.parse(attr.value);
                        return getLocalizedText(parsedValue, language);
                    } catch {
                        return getLocalizedText(attr.value, language);
                    }
                })
                .filter(value => value && value.trim() !== "");

            if (attributeParts.length > 0) {
                return attributeParts.join(' / ');
            }
        }

        // Try to get from nested variant object
        if (item.variant && typeof item.variant === 'object') {
            const nestedVariant = item.variant.name || item.variant.title || item.variant.display;
            if (nestedVariant) {
                const localizedVariant = getLocalizedText(nestedVariant, language);
                if (localizedVariant && localizedVariant.trim() !== "") {
                    return localizedVariant;
                }
            }
        }

        return null;
    }
};